import './Login.css';

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { StylesProvider } from "@material-ui/core/styles";

import Services from '../../tools/Services';

import Link             from '@material-ui/core/Link';
import Grid             from '@material-ui/core/Grid';
import Checkbox         from '@material-ui/core/Checkbox';
import TextField        from '@material-ui/core/TextField';
import Container        from '@material-ui/core/Container';
import Typography       from '@material-ui/core/Typography';
import CssBaseline      from '@material-ui/core/CssBaseline';
import ForgotPassword   from './ForgotPassword';
import LoadingButton from '../LoadingButton/LoadingButton';

const PRIVATE_RADAR_LOGO_URL = "https://cloudfront.private-radar.com/img/logo/logo_login.png";

export default class Login extends Component {
	state = {
		name: '',
		email: '',
		error: '',
		password: '',
		open: false,
		redirect: false,
		rememberMe: false,
		showPassword: false,
		isLoading: false
	};
	
	componentDidMount() {
		// If there is a token, go to map
		let token = Services.getToken();
		if (token !== null)
			this.setState({ redirect: true });
	}
	
	handleSubmit = async (e) => {
		//Prevent reset on Submit
		e.preventDefault();

		const { email, password } = this.state;

		// Check if fields are empty
		if (email === '' || password === '') {
			this.setState({ error: 'Please fill in your email and password' }); // TODO SR
			return;
		}

		// Post
		this.setState({isLoading:true});
		let res = await Services.post('login/login', { email, password, info :"map" });
		this.setState({isLoading:false});

		// Error
		if (res.status !== 'success') {
			this.setState({ error: this.getReadableError(res.error) });
			return;
		}
		
		// Success => save token
		Services.setToken(res.token, this.state.rememberMe);
		
		// Setting user and 
		// company for display in 
		// SchedualeDialog if it is a company 
		if(res.company !== undefined)
			localStorage.setItem('comp', JSON.stringify(res.company));

		else
			// get first and last name if not a company 
			localStorage.setItem('user', JSON.stringify(res.user));
		
		// go to map
		this.setState({ redirect: true });
	}

	getReadableError(error) {
		switch(error) {
			case 'E001':
				return 'This IP has been blocked.';// TODO SR
			case 'E002':
				return 'You are in a different country than your usual one. Please answer the email you received to confirm the location.';// TODO SR
			case 'ERROR_EMAIL_PWD_INCORRECT':
				return 'Invalid username or password'; // TODO SR
			case 'ERROR_NOT_AUTHORIZED':
				return 'Login not authorized'; // TODO SR
			default:
				return 'Unknown error';
		}
	}

	// Handles
	handleClose = (e) => {
		this.setState({ open: false });
	}
	
	handleChange = (e) => {
		
		let creds = Object.assign({}, this.state);
		creds[e.target.name] = e.target.value;
		this.setState({ email: creds.email, password: creds.password });
	}

	handleLinkClick = (e) => {
		this.setState({ open: true });
	}

	handleCheckboxChange = (e) => {
		let rememberMe = e.target.checked;
		this.setState({ rememberMe });
	}

	handleClickShowPassword = (e) => {
		let showPassword = this.state.showPassword;
		this.setState({ showPassword: !showPassword });
	}

	handleMouseDownPassword = (e) => {
		e.preventDefault();
	}

	render() {
		const { email, password, error, redirect, rememberMe, showPassword, open, isLoading } = this.state

		return (
			<StylesProvider injectFirst>
			<div id='LoginScreen'>
				{redirect && <Redirect to='/map' />}

				<div id='Login' >
				<ForgotPassword open={open} onClose={this.handleClose}/>  
				
					<Container component="main">
						<CssBaseline />
						<div className='loginContent'>
							<div className="logo">
								<img alt='Private-Radar' src={PRIVATE_RADAR_LOGO_URL}></img>
							</div>
							<Typography component="h6">
								<div class="section-popular-times-now-badge">Aircraft Tracking System</div>
							</Typography>

							<form oValidate>
								<TextField 
									onChange={this.handleChange} 
									value={email} 
									autoFocus 
									label="Username/Email" 
									name='email' 
									type='text' 
									id='username'
									className='loginUser'   
									variant="outlined"
									margin="normal" 
									fullWidth
								/>
								<TextField
									onChange = {this.handleChange}
									value = {password}
									type = {showPassword ? 'text' : 'password'}
									id = "standard-adornment-password"
									name = 'password'
									label = 'Password' 
									className = 'loginPwd'
									variant = "outlined"
									margin = "normal"
									required
									fullWidth
								/>
								<div>
									<Checkbox
										color="primary"
										name='rememberMe'
										value={rememberMe}
										checked={rememberMe}
										onChange={this.handleCheckboxChange}
									/>
									<span>Remember me</span>
								</div>								
								<LoadingButton
									id = "signInButton"
									isLoading={isLoading}
									onClick={this.handleSubmit}
									label='Sign In'
								/>
								<div className='errorMessage'>{error}</div>
								<Grid container>
									<Grid item xs>
									<Link href="#" variant="body2">
									</Link>
									</Grid>
									<Grid item>
									{/* <Link onClick={this.handleLinkClick} variant="body2">
										Forgot password?
									</Link> */}
									</Grid>
								</Grid>
							</form>
						</div>
					</Container>
				</div>
			</div>
			</StylesProvider>
		)
	}
}

